/**
 * Iconos y etiquetas por plataforma. Un solo lugar para que el nombre de
 * la red se vea igual en el panel, el compositor y el historial.
 */
import React from 'react';
import {
  Facebook, Globe, Instagram, Linkedin, MessageCircle,
  Music2, Pin, Twitter, Youtube,
} from 'lucide-react';

const MAP = {
  instagram: { label: 'Instagram', Icon: Instagram, color: '#e1306c' },
  facebook: { label: 'Facebook', Icon: Facebook, color: '#1877f2' },
  linkedin: { label: 'LinkedIn', Icon: Linkedin, color: '#0a66c2' },
  twitter: { label: 'X (Twitter)', Icon: Twitter, color: '#e7e9ea' },
  youtube: { label: 'YouTube', Icon: Youtube, color: '#ff0000' },
  tiktok: { label: 'TikTok', Icon: Music2, color: '#25f4ee' },
  pinterest: { label: 'Pinterest', Icon: Pin, color: '#e60023' },
  threads: { label: 'Threads', Icon: MessageCircle, color: '#ffffff' },
  bluesky: { label: 'Bluesky', Icon: MessageCircle, color: '#0085ff' },
  mastodon: { label: 'Mastodon', Icon: MessageCircle, color: '#6364ff' },
  googlebusiness: { label: 'Google Business', Icon: Globe, color: '#4285f4' },
  startpage: { label: 'Start Page', Icon: Globe, color: '#10b981' },
  whatsapp: { label: 'WhatsApp', Icon: MessageCircle, color: '#25d366' },
};

export const platformMeta = (platform) =>
  MAP[(platform || '').toLowerCase()] || { label: platform || 'Red', Icon: Globe, color: '#94a3b8' };

export const PlatformIcon = ({ platform, size = 14 }) => {
  const { Icon, color } = platformMeta(platform);
  return <Icon size={size} style={{ color }} />;
};

export const CHANNEL_STATUS_LABEL = {
  connected: 'Conectado',
  disconnected: 'Necesita reconexión',
  locked: 'Bloqueado en el plan',
  paused: 'Cola pausada',
  removed: 'Ya no existe',
};

export const POST_STATUS_LABEL = {
  draft: 'Borrador',
  validating: 'Validando',
  queued: 'En cola',
  scheduled: 'Programada',
  publishing: 'Publicando',
  published: 'Publicada',
  partial: 'Publicación parcial',
  failed: 'Falló',
  cancelled: 'Cancelada',
};

export const TARGET_STATUS_LABEL = {
  pending: 'Pendiente',
  publishing: 'Publicando',
  scheduled: 'Programada',
  published: 'Publicada',
  draft: 'Borrador',
  failed: 'Falló',
  cancelled: 'Cancelada',
};
